import clsx from 'clsx';
import ImageComp from 'components/ui/Image';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import styles from './Image.module.scss';
import RichText from './RichText';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type { IBlockImageFields } from 'types/contentful/generated';
import type { Document } from '@contentful/rich-text-types';

type Props = IBlockImageFields & {
  descriptionContent?: Document;
  inspectorProps?: InspectorPropsType;
};

const Image = ({
  blockId,
  title,
  description,
  descriptionContent,
  image,
  imageAlignment = 'Left',
  inspectorProps,
}: Props): JSX.Element => {
  const alignClass = {
    Left: styles.alignLeft,
    Center: styles.alignCenter,
    Right: styles.alignRight,
  };

  const textAlignment = {
    Left: 'text-left',
    Center: 'text-center',
    Right: 'text-right',
  };

  // eslint-disable-next-line
  // @ts-ignore
  const imageDescription = image?.fields?.description || image?.description;
  // eslint-disable-next-line
  // @ts-ignore
  const imageTitle = image?.fields?.title || image?.title;

  return (
    <div
      id={sanitizeContentfulBlockId(blockId)}
      className={styles.container}
      {...inspectorProps?.({ fieldId: 'image' })}
    >
      {title && <h2 className={styles.headline}>{title}</h2>}
      <div className={clsx(styles.imageWrapper, alignClass[imageAlignment])}>
        <ImageComp
          // eslint-disable-next-line
          // @ts-ignore
          src={image?.fields?.file.url || image?.url}
          alt={imageDescription || imageTitle || ''}
          // eslint-disable-next-line
          // @ts-ignore
          width={image?.fields?.file.details.image?.width || image?.width}
          // eslint-disable-next-line
          // @ts-ignore
          height={image?.fields?.file.details.image?.height || image?.height}
          contentful
        />
      </div>
      {(descriptionContent || description) && (
        <div className={clsx('py-2', textAlignment[imageAlignment])}>
          <RichText fields={descriptionContent || description} />
        </div>
      )}
    </div>
  );
};

export default Image;
